import { render, staticRenderFns } from "./RcWidgetLiveResultsGovernor.vue?vue&type=template&id=08d625cb&"
import script from "./RcWidgetLiveResultsGovernor.vue?vue&type=script&lang=js&"
export * from "./RcWidgetLiveResultsGovernor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports